export default {
  postureReport: "Raport postawy",
  postureData: "Dane postawy",
  postureDataContrast: "Kontrast danych postawy",
  postureRiskContrast: "Kontrast ryzyka postawy",
  postureDataTrend: "Tendencja danych postawy",
  postureRiskTrend: "Tendencja ryzyka postawy",
  postureLogData: "Dane dziennika postawy",
  lateralhead: "Boczny przechyl głowy",
  unevenshoulder: "Nierówne ramiona",
  scoliosis: "Skolioza",
  unevenhip: "Przechyl boczny miednicy",
  xleg: "Noga w kształcie X",
  oleg: "Noga w kształcie O",
  roundedshoulder: "Zaokrąglone ramię",
  kneehyperextension: "Hiperrozciąganie kolana",
  trunkforwardtilt: "Trunk forward tilt",
  trunklateraltilt: "Trunk Lateral Tilt",
  forwardhead: "Głowa do przodu",
  toTheLeft: "（lewa）",
  toTheRight: "（prawa）",
  bracketsLeft: "（L）",
  bracketsRight: "（R）",
  bracketsNormal: "（Normalny）",
  leg: "Nogi",
  legLeft: "Nogi (L)",
  legRight: "Nogi (R)",
  riskAssessment: "Ocena ryzyka",
  muscleState: "Stan mięśni",
  muscleStateDesc: "Nie znaleziono żadnych nieprawidłowych stanów mięśniowych",
  testTime: "Czas testu",
  hRisk: "H",
  mRisk: "M",
  lRisk: "L",
  item: "Pozycja",
  degree: "°",
  percent: "%",
  mm: "mm",
  moireImage: "Obraz mory",
  lAbnormalRisk: "L Ryzyko",
  mAbnormalRisk: "M Ryzyko",
  hAbnormalRisk: "",
  highRisk: "Wysokie ryzyko",
  riskAnalysis: "Analiza ryzyka",
  conclusionRecommendation: "Zalecenie i wniosek",
  solution: "Rozwiązanie",
  movePosition: "Kliknij kropkę, aby przenieść pozycję",
  confirmTheClose: "Nie zapisano jeszcze, czy potwierdzić zamknięcie?",
  closeInfo: "Nie zapisano jeszcze, czy potwierdzić zamknięcie?",
  share: "Dzielić się",
  front: "Przód",
  side: "Bok",
  back: "Tyl",
  otherSide: "Druga Strona",
  points: "Punkty",
  angle: "Kąt",
  name: "Nazwa",
  gender: "Płeć",
  male: "Mężczyzna",
  female: "Kobieta",
  age: "Wiek",
  year: "lata",
  height: "Wysokość",
  weight: "Waga",
  time: "Czas",
  patientId: "ID pacjenta",
  save: "Zapisz",
  saveModify: "Zapisz modyfikację",
  print: "Drukować",
  cancel: "Anuluj",
  zoomIn: "Powiększyć",
  zoomOut: "Pomniejszyć",
  ok: "OK",
  return: "Powrót",
  empty: "",
  unknown: "Nieznany",
  succeedToCopy: "Skopiowano pomyślnie",
  succeedToSave: "Zapisano pomyślnie",
  headForwardDistance: "Odległość głowy do przodu",
  pelvisForwardTilt: "Przechył miednicy do przodu",
  wristHipDistanceLeft: "Odległość nadgarstek-biodro (Lewa)",
  wristHipDistanceRight: "Odległość nadgarstek-biodro (Prawa)",
  wristHipDistanceRight: "Odległość od nadgarstka do biodra (prawa)",
  evaluator: "Oceniający",
  reportDate: "Data raportu",
  introduction: "Wprowadzenie",
  doctorIntroDefault: "Specjalizacja: Medycyna rehabilitacyjna, ocena i korekta postawy | Doświadczenie zawodowe: więcej niż 5 lat | Kompetencje: Rehabilitacja po urazach sportowych, korekta postawy, zarządzanie bólem",
  recoveryLog: "Dziennik odzyskiwania",
  returnToReport: "Powrót do raportu",
  loading: "Ładowanie...",
  showToolbox: "Pokaż przybornik",
  hideToolbox: "Ukryj przybornik",
};

